import { Link } from "react-router-dom";
import { Button, Icon } from "@/components/ui";

export default function ForbiddenPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-8" role="alert">
      <div className="max-w-[480px] text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-danger-soft text-danger mb-5">
          <Icon name="shieldAlt" size={26} />
        </div>
        <div className="text-[11px] uppercase tracking-eyebrow text-muted font-semibold mb-2">
          Error 403 · Acceso denegado
        </div>
        <h1 className="font-serif text-3xl font-medium tracking-tightish mb-3">
          No tienes permisos para ver esta sección.
        </h1>
        <p className="text-sm text-text-2 leading-relaxed mb-6">
          Si crees que esto es un error, contacta al administrador del workspace
          para revisar los permisos asignados a tu cuenta.
        </p>
        <div className="flex justify-center gap-2">
          <Link to="/dashboard">
            <Button variant="primary" size="md">Volver al dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
